import React, { useState, useEffect, ReactNode } from 'react';
import {
  useFloating,
  offset,
  shift,
  flip,
  autoUpdate,
} from '@floating-ui/react-dom';
import { TooltipContext } from './TooltipContext';

interface TooltipProps {
  children: ReactNode;
}

export const Tooltip: React.FC<TooltipProps> = ({ children }) => {
  const [open, setOpen] = useState(false);

  const { x, y, strategy, refs, update } = useFloating({
    placement: 'top',
    middleware: [offset(8), flip(), shift({ padding: 8 })],
    whileElementsMounted: autoUpdate,
  });

  // Update position when open state changes
  useEffect(() => {
    if (open) {
      update();
    }
  }, [open, update]);

  return (
    <TooltipContext.Provider value={{ open, setOpen, refs, x, y, strategy }}>
      {children}
    </TooltipContext.Provider>
  );
};
